<template>

	<div>
        <div class="twin-title-container">
            <h2 class="twin-title">
              Verify who you are
            </h2>
            <p class="text-xs twin-subtext">
              For security purposes, please sign in so we can verify who you are
            </p>
        </div>
        <div class="twin-form">
            <account @loggedIn="loginRedirect" @social="socialCheck" :register="false"></account>
        </div>
  	</div>

</template>

<script>
	import account from '../../components/quote/initial/account.vue'; 
	export default {
		components: {
			account
		},
		data() {
			return {
				quote: false,
			}
		},
		methods: {
			getQuote() {
				const self = this;

				axios.get('quote/getQuote')
					 .then((resp) => {
					 	if(resp.data && resp.data.quote) {
					 			self.quote = resp.data.quote;
					 	}
					 })
					 .catch(error => {

					 });
			},
			loginRedirect() {
				const self = this;

				// Ensure Quote is assigned to Client
				axios.post('quote/assignClient')
					 .then((resp) => {
					 	if(resp.data) {
					 		if(resp.data.success) {
					 			window.location.href = self.baseUrl+'/quote/';
					 		}
					 	}
					 })
					 .catch(error => {
					 });
			},
			socialCheck(e) {
				this.getQuote();
		
				// stop interval if popup is closed manually
				if(e.popup.closed) {
					clearInterval(e.check);
				}

				if(this.quote.client) {
					e.popup.close();

					// relocate to quote page
					this.loginRedirect();
				}
			}
		}
	}
</script>